export default function onReady(fn) {
    if (document.readyState === 'loading') {
        // still loading, so wait for it
        document.addEventListener('DOMContentLoaded', fn);
    } else {
        // already past it — fire “on next tick”
        setTimeout(fn, 0);
    }
}
